import { useState, useEffect } from 'react';

import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeIcon from '../../components/NodeIcon';
import TrueFalseHandles from '../../components/TrueFalseHandles';
import NodeHeader from '../NodeHeader';
import NodeWrapper from '../NodeWrapper';

import type { CalendarType } from './CalendarControls';
import type { NodeProps } from '@xyflow/react';
import type { GetOneResult } from 'react-admin';

export default function CalendarNode({ data }: NodeProps & { data: CalendarType }): React.ReactElement {
  const [calendar, setCalendar] = useState<GetOneResult['data'] | null>(null);
  const translate = useTranslate();

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      if (data.calendar !== undefined && data.calendar !== null) {
        setCalendar(data.calendar);
      } else {
        setCalendar(null);
      }
    };
    void fetchData();
  }, [data.calendar]);

  const errors =
    data.calendar === undefined || data.calendar === null ? ['callflows.nodes.calendar.calendarIsNotSelected'] : [];

  return (
    <NodeWrapper errors={errors}>
      <NodeHeader
        icon={<NodeIcon name='calendar' />}
        title={calendar?.title !== undefined ? calendar.title : translate('callflows.nodes.calendar.name')}
      />
      <Handle type='target' position={Position.Left} id='calendar-target' />
      <TrueFalseHandles />
    </NodeWrapper>
  );
}
